
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/m/playzone",
      function () {
        return require("private-next-pages/m/playzone/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/m/playzone"])
      });
    }
  